import axios from "axios";
import cfg from "@/config";

// Javni link za dobavljaca (narudzbenica). Bez prijave: namjerno samostalna axios instanca
// koja NE salje 'restoran-token' ni header 'restaurant' (kao plugins/axios.js), jer ova
// stranica nema veze sa nalogom onoga ko je otvori (npr. restoran koji testira svoj link).
const client = axios.create({ baseURL: cfg.apiUrl });

const base = (token) => `/supplier-po/${encodeURIComponent(token)}`;

const supplierPoService = {
  get(token) {
    return client.get(base(token));
  },
  // evidentira otvaranje (poziva se tek kad se stranica prikaze, ne pri prefetch-u)
  opened(token) {
    return client.post(`${base(token)}/opened`);
  },
  respond(token, payload) {
    return client.post(`${base(token)}/respond`, payload);
  },
};

export default supplierPoService;
